import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Button, Form, Modal } from "react-bootstrap";
import AsyncButton from "common/ui/AsyncButton";
import Commodity from "domain/commodity";

export type CommodityProps = {
    appendTitle?: string;
    commodities: Commodity[];
    existingCommodities: number[];
    showModal: boolean;
    isReadOnly: boolean;
    handleSubmit(commodities: number[]): Promise<any>;
    handleCancel: () => void;
};

const CommoditiesModal: React.FC<CommodityProps> = (props: CommodityProps) => {
  const [selectedCommodities, setSelectedCommodities] = useState<number[]>([]);
  
  useEffect(() => {
    if(props.existingCommodities == null) return;
    setSelectedCommodities(props.existingCommodities);
      
  }, [props.existingCommodities])

  function selectAll() {
    setSelectedCommodities(props.commodities.map(c => c.id));
  }
  
  function unselectAll() {
    setSelectedCommodities([]);
  }

  function toggle(commodity: Commodity, isChecked: boolean) {
    if(isChecked) {
      setSelectedCommodities([...selectedCommodities, commodity.id])
    }
    else {
      setSelectedCommodities(selectedCommodities.filter(m => m !== commodity.id));
    }
  }

  async function handleSubmit() {
    props.handleSubmit(selectedCommodities);        
    onClose();
  }
  
  function onClose() {
    setSelectedCommodities([]);
    props.handleCancel();
  }

  function isAllSelected(){
      return selectedCommodities.length === props.commodities.length;
  }

    return <Modal show={props.showModal} dialogClassName="modal-md" onHide={onClose} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Commodities {props.appendTitle ? ` - ${props.appendTitle}` : ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    {!props.isReadOnly && !isAllSelected() && <button type="button" className="link-button"
                        onClick={selectAll}>
                        Select All
                    </button>}
                    {!props.isReadOnly && isAllSelected() && <button type="button" className="link-button"
                        onClick={unselectAll}>
                            Unselect All
                    </button>}

                    {props.commodities.map(c => <Form.Check 
                        key={c.id}
                        id={"commodity-" + c.id}
                        checked={selectedCommodities.some(m => c.id === m)}
                        disabled={props.isReadOnly}
                        onChange={ev => toggle(c, ev.target.checked)}
                        label={c.displayName ?? c.name}
                    />)}
            </Modal.Body>
            <Modal.Footer className="align center">
                {!props.isReadOnly && <><Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <AsyncButton variant="primary" onClickAsync={handleSubmit}>
                    Save
                </AsyncButton></>}
            </Modal.Footer>
        </Modal>;
}
  

export default CommoditiesModal;